import EventEmitter from '@utils/eventEmitter';
import { ActionChangedEvent, ActionPath, EVENTS } from './actionRequiredService';

class ActionStore {
  private store: Record<string, any> = {};

  private eventEmitter: EventEmitter<ActionChangedEvent>;

  constructor(
    eventEmitter: EventEmitter<ActionChangedEvent>,
    store: Record<string, any> = {},
  ) {
    this.eventEmitter = eventEmitter;
    this.store = store;
  }

  private setKey(
    path: ActionPath,
    object: Record<string, any>,
    value: boolean,
    parentPath: ActionPath,
  ) {
    if (path.length === 0) {
      return;
    }

    if (path.length === 1) {
      if (value) {
        // eslint-disable-next-line no-param-reassign
        object[path[0]] = value;
        this.eventEmitter.emit(EVENTS.ACTION_CHANGED, {
          path: [...parentPath, path[0]],
          value,
        });
      } else {
        // Remove the key entirely when setting to false
        // eslint-disable-next-line no-param-reassign
        delete object[path[0]];
        this.eventEmitter.emit(EVENTS.ACTION_CHANGED, {
          path: [...parentPath, path[0]],
          value: false,
        });
      }
      return;
    }

    // Create intermediate object if it doesn't exist or is not an object
    if (typeof object[path[0]] !== 'object' || Array.isArray(object[path[0]])) {
      // eslint-disable-next-line no-param-reassign
      object[path[0]] = {};
      this.setKey(path.slice(1), object[path[0]], value, [...parentPath, path[0]]);
      this.eventEmitter.emit(EVENTS.ACTION_CHANGED, {
        path: [...parentPath, path[0]],
        value,
      });
    } else {
      this.setKey(path.slice(1), object[path[0]], value, [...parentPath, path[0]]);

      // Clean up empty objects after setting to false
      if (!value && Object.keys(object[path[0]]).length === 0) {
        // eslint-disable-next-line no-param-reassign
        delete object[path[0]];
        this.eventEmitter.emit(EVENTS.ACTION_CHANGED, {
          path: [...parentPath, path[0]],
          value: false,
        });
      }
    }
  }

  setAction(path: ActionPath, value: boolean) {
    this.setKey(path, this.store, value, []);
  }

  clearAction(path: ActionPath) {
    this.setKey(path, this.store, false, []);
  }

  getStore() {
    return this.store;
  }
}
export default ActionStore;
